import * as RadixTooltip from '@radix-ui/react-tooltip';

import { IsTouchProvider } from './IsTouchContext';
import type { TooltipProviderProps } from './types';

export const TooltipProvider = ({
  children,
  delayDuration = 300,
  skipDelayDuration = 300,
  disableHoverableContent = false,
}: TooltipProviderProps) => (
  <RadixTooltip.Provider
    delayDuration={delayDuration}
    skipDelayDuration={skipDelayDuration}
    disableHoverableContent={disableHoverableContent}
  >
    <IsTouchProvider>{children}</IsTouchProvider>
  </RadixTooltip.Provider>
);
